import React from 'react';
import { CTAButton } from './CTAButton';
export function Problem() {
  return <section className="w-full bg-cream px-5 py-14 sm:px-6 sm:py-20" data-id="element-211" data-mp="2pf8pw8d587n0">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-212" data-mp="2pdef3mvl5vwn">
        <h2 className="font-display text-[28px] font-extrabold leading-tight text-ofm-900 sm:text-4xl" data-id="element-213" data-mp="2beo89fiyshv3">
          La diferencia entre adivinar… y decidir con criterio.
        </h2>

        <p className="mt-5 text-[15px] leading-relaxed text-ofm-900/70 sm:text-lg" data-id="element-214" data-mp="21pehc2zux58k">
          Cada día llegan niños con Clase II, mordidas cruzadas, hábitos
          funcionales o alteraciones del crecimiento.
        </p>

        <div className="mt-8 space-y-4" data-id="element-215" data-mp="1sqj6ueps58zg">
          <div className="rounded-2xl border border-ofm-200 bg-white p-5" data-id="element-216" data-mp="1snewt0pmvj0v">
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-ofm-800/50" data-id="element-217" data-mp="1wr35jmq04knp">
              La pregunta nunca es
            </p>
            <p className="mt-2 font-display text-xl italic text-ofm-900/60 line-through decoration-[#D93A2B]/60 sm:text-2xl" data-id="element-218" data-mp="1npvg7u5gqu5r">
              “¿Qué aparato conozco?”
            </p>
          </div>

          <div className="rounded-2xl bg-ofm-800 p-5 shadow-lg" data-id="element-219" data-mp="ob3ys5s2hvfv">
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-ofm-200" data-id="element-220" data-mp="ocycaz10el9x">
              La verdadera pregunta es
            </p>
            <p className="mt-2 font-display text-xl font-bold italic text-white sm:text-2xl" data-id="element-221" data-mp="xbaapn84ancx">
              “¿Qué aparato necesita realmente este paciente?”
            </p>
          </div>
        </div>

        <p className="mt-8 text-[15px] leading-relaxed text-ofm-900/70 sm:text-lg" data-id="element-222" data-mp="5l5i51a7eu0m">
          Y esa respuesta no se obtiene por intuición.
          <br data-id="element-223" data-mp="jd27wyoegrtu" />
          <span className="font-bold text-ofm-900" data-id="element-224" data-mp="jdlpufe1vg7v">
            Se obtiene siguiendo un proceso diagnóstico.
          </span>
        </p>
        <p className="mt-3 text-[15px] font-semibold text-ofm-700 sm:text-lg" data-id="element-225" data-mp="3n0ccsm3lti8q">
          Eso es exactamente lo que aprenderás con el Sistema OFM.
        </p>

        <CTAButton className="mt-9" label="🦷 QUIERO DECIDIR CON CRITERIO" subline="Acceso inmediato por $12.99 USD · Pago único" data-id="element-226" data-mp="3hzoi9qg62j9r" />
      </div>
    </section>;
}